import React, { useState, useEffect } from 'react';
import axios from 'axios';

function HotelReservations() {
  const [rooms, setRooms] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('reservations');
  const [modal, setModal] = useState({ open: false, type: null });
  const [form, setForm] = useState({});
  const [filter, setFilter] = useState('');
  const [customerQuery, setCustomerQuery] = useState('');
  const [customerResults, setCustomerResults] = useState([]);
  const [newCustomerMode, setNewCustomerMode] = useState(false);
  const [newCustomer, setNewCustomer] = useState({ first_name: '', last_name: '', phone: '' });
  const token = localStorage.getItem('crm_token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [rm, rv] = await Promise.all([
        axios.get('/api/hotel/rooms', { headers }),
        axios.get('/api/hotel/reservations', { headers })
      ]);
      setRooms(rm.data);
      setReservations(rv.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const saveRoom = async () => {
    try {
      if (form.id) await axios.put(`/api/hotel/rooms/${form.id}`, form, { headers });
      else await axios.post('/api/hotel/rooms', form, { headers });
      setModal({ open: false }); setForm({}); fetchAll();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  const searchCustomers = async (q) => {
    setCustomerQuery(q);
    if (!q.trim()) { setCustomerResults([]); return; }
    try {
      const res = await axios.get(`/api/customers?search=${encodeURIComponent(q)}&limit=8`, { headers });
      setCustomerResults(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (e) { console.error(e); }
  };

  const selectCustomerForReservation = (c) => {
    setForm({ ...form, customer_id: c.id });
    setCustomerQuery(`${c.first_name} ${c.last_name || ''}`.trim());
    setCustomerResults([]);
  };

  const createCustomerForReservation = async () => {
    if (!newCustomer.first_name.trim() || !newCustomer.phone.trim()) {
      alert('Ad ve telefon zorunludur'); return;
    }
    try {
      const res = await axios.post('/api/customers', newCustomer, { headers });
      selectCustomerForReservation(res.data);
      setNewCustomerMode(false);
      setNewCustomer({ first_name: '', last_name: '', phone: '' });
    } catch (e) { alert(e.response?.data?.error || 'Müşteri oluşturulamadı'); }
  };

  const saveReservation = async () => {
    if (!form.customer_id) {
      alert('Lütfen önce bir misafir seçin veya yeni müşteri ekleyin.');
      return;
    }
    try {
      await axios.post('/api/hotel/reservations', form, { headers });
      setModal({ open: false }); setForm({}); setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false);
      fetchAll();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  const updateReservationStatus = async (id, status) => {
    await axios.put(`/api/hotel/reservations/${id}/status`, { status }, { headers });
    fetchAll();
  };

  const deleteRoom = async (id) => {
    if (!window.confirm('Oda silinsin mi?')) return;
    await axios.delete(`/api/hotel/rooms/${id}`, { headers });
    fetchAll();
  };

  const roomTypeLabels = { single: 'Tek Kişi', double: 'Çift Kişi', suite: 'Süit', deluxe: 'Deluxe', family: 'Aile' };
  const roomStatusColors = { available: '#10B981', occupied: '#EF4444', cleaning: '#F59E0B', maintenance: '#6B7280', reserved: '#3B82F6' };
  const roomStatusLabels = { available: 'Müsait', occupied: 'Dolu', cleaning: 'Temizlik', maintenance: 'Bakım', reserved: 'Rezerve' };
  const resStatusColors = { pending: '#F59E0B', confirmed: '#3B82F6', checked_in: '#10B981', checked_out: '#6B7280', cancelled: '#EF4444', no_show: '#9CA3AF' };
  const resStatusLabels = { pending: 'Bekliyor', confirmed: 'Onaylı', checked_in: 'Giriş Yaptı', checked_out: 'Çıkış Yaptı', cancelled: 'İptal', no_show: 'Gelmedi' };

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  const filteredRes = filter ? reservations.filter(r => r.status === filter) : reservations;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">🏨 Otel Yönetimi</h1>
          <p className="page-subtitle">Oda ve rezervasyon yönetimi</p>
        </div>
        <div className="header-actions">
          <button className="btn btn-primary" onClick={() => {
            setForm({});
            setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false);
            setModal({ open: true, type: activeTab === 'rooms' ? 'room' : 'reservation' });
          }}>+ {activeTab === 'rooms' ? 'Yeni Oda' : 'Yeni Rezervasyon'}</button>
        </div>
      </div>

      <div className="tabs-bar">
        {[['reservations', '📋 Rezervasyonlar'], ['rooms', '🛏️ Odalar']].map(([k, v]) => (
          <button key={k} className={`tab-btn ${activeTab === k ? 'active' : ''}`} onClick={() => setActiveTab(k)}>{v}</button>
        ))}
      </div>

      {activeTab === 'rooms' && (
        <div className="room-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '16px', marginTop: '20px' }}>
          {rooms.map(r => (
            <div key={r.id} className="card" style={{ padding: '20px', cursor: 'pointer', borderLeft: `4px solid ${roomStatusColors[r.status]}` }}
              onClick={() => { setForm(r); setModal({ open: true, type: 'room' }); }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ fontSize: '24px', fontWeight: '700' }}>#{r.room_number}</span>
                <span className="badge" style={{ background: roomStatusColors[r.status] + '20', color: roomStatusColors[r.status] }}>
                  {roomStatusLabels[r.status]}
                </span>
              </div>
              <div style={{ fontSize: '14px', color: 'var(--gray-500, #64748b)' }}>{roomTypeLabels[r.room_type]} • {r.capacity} kişi</div>
              <div style={{ fontSize: '16px', fontWeight: '600', marginTop: '8px' }}>
                {r.price_per_night ? `${Number(r.price_per_night).toLocaleString('tr-TR')} ₺/gece` : '-'}
              </div>
              <button className="btn btn-ghost btn-sm" style={{ marginTop: '8px' }} onClick={(e) => { e.stopPropagation(); deleteRoom(r.id); }}>🗑️ Sil</button>
            </div>
          ))}
          {rooms.length === 0 && <div className="card" style={{ padding: '40px', textAlign: 'center', gridColumn: '1 / -1', color: 'var(--gray-400)' }}>Henüz oda eklenmemiş</div>}
        </div>
      )}

      {activeTab === 'reservations' && (
        <>
          <div style={{ display: 'flex', gap: '8px', marginTop: '16px', flexWrap: 'wrap' }}>
            <button className={`btn btn-sm ${!filter ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setFilter('')}>Tümü</button>
            {Object.entries(resStatusLabels).map(([k, v]) => (
              <button key={k} className={`btn btn-sm ${filter === k ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setFilter(k)}>{v}</button>
            ))}
          </div>
          <div className="card mt-4">
            <div className="table-container">
              <table className="table">
                <thead><tr><th>Misafir</th><th>Oda</th><th>Giriş</th><th>Çıkış</th><th>Fiyat</th><th>Durum</th><th>İşlem</th></tr></thead>
                <tbody>
                  {filteredRes.map(r => (
                    <tr key={r.id}>
                      <td>
                        <div className="font-medium">{r.first_name} {r.last_name}</div>
                        <div className="text-xs text-muted">{r.phone}</div>
                      </td>
                      <td>#{r.room_number} ({roomTypeLabels[r.room_type] || r.room_type})</td>
                      <td>{new Date(r.check_in).toLocaleDateString('tr-TR')}</td>
                      <td>{new Date(r.check_out).toLocaleDateString('tr-TR')}</td>
                      <td>{r.total_price ? `${Number(r.total_price).toLocaleString('tr-TR')} ₺` : '-'}</td>
                      <td>
                        <span className="badge" style={{ background: resStatusColors[r.status] + '20', color: resStatusColors[r.status] }}>
                          {resStatusLabels[r.status]}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          {r.status === 'confirmed' && <button className="btn btn-sm btn-primary" onClick={() => updateReservationStatus(r.id, 'checked_in')}>Check-in</button>}
                          {r.status === 'checked_in' && <button className="btn btn-sm btn-secondary" onClick={() => updateReservationStatus(r.id, 'checked_out')}>Check-out</button>}
                          {['pending', 'confirmed'].includes(r.status) && <button className="btn btn-sm btn-ghost" onClick={() => updateReservationStatus(r.id, 'cancelled')}>İptal</button>}
                        </div>
                      </td>
                    </tr>
                  ))}
                  {filteredRes.length === 0 && <tr><td colSpan="7" className="text-center text-muted" style={{ padding: '40px' }}>Rezervasyon bulunamadı</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {modal.open && (
        <div className="modal-overlay" onClick={() => setModal({ open: false })}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h2>{modal.type === 'room' ? (form.id ? 'Oda Düzenle' : 'Yeni Oda') : 'Yeni Rezervasyon'}</h2>
              <button className="modal-close" onClick={() => setModal({ open: false })}>×</button>
            </div>
            <div className="modal-body">
              {modal.type === 'room' ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div className="form-group"><label className="form-label">Oda No</label>
                    <input className="input" value={form.room_number || ''} onChange={e => setForm({ ...form, room_number: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Oda Tipi</label>
                    <select className="select" value={form.room_type || 'double'} onChange={e => setForm({ ...form, room_type: e.target.value })}>
                      {Object.entries(roomTypeLabels).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Kapasite</label>
                    <input type="number" className="input" value={form.capacity || 2} onChange={e => setForm({ ...form, capacity: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Gecelik Fiyat (₺)</label>
                    <input type="number" className="input" value={form.price_per_night || ''} onChange={e => setForm({ ...form, price_per_night: e.target.value })} />
                  </div>
                  {form.id && (
                    <div className="form-group"><label className="form-label">Durum</label>
                      <select className="select" value={form.status || 'available'} onChange={e => setForm({ ...form, status: e.target.value })}>
                        {Object.entries(roomStatusLabels).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                      </select>
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div className="form-group">
                    <label className="form-label">Misafir *</label>
                    {form.customer_id ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', background: 'var(--gray-100, #f1f5f9)', borderRadius: '8px' }}>
                        <span style={{ fontWeight: 500, flex: 1 }}>{customerQuery}</span>
                        <button type="button" className="btn btn-ghost btn-sm" onClick={() => { setForm({ ...form, customer_id: undefined }); setCustomerQuery(''); }}>Değiştir</button>
                      </div>
                    ) : !newCustomerMode ? (
                      <>
                        <input className="input" placeholder="İsim veya telefon ile ara..." value={customerQuery} onChange={e => searchCustomers(e.target.value)} />
                        {customerResults.length > 0 && (
                          <div style={{ border: '1px solid var(--border, #e2e8f0)', borderRadius: '8px', marginTop: '4px', maxHeight: '160px', overflowY: 'auto' }}>
                            {customerResults.map(c => (
                              <div key={c.id} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border, #e2e8f0)' }}
                                onClick={() => selectCustomerForReservation(c)}>
                                <div style={{ fontWeight: 500 }}>{c.first_name} {c.last_name}</div>
                                <div style={{ fontSize: '12px', color: '#64748b' }}>{c.phone}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        <button type="button" className="btn btn-ghost btn-sm" style={{ marginTop: '6px' }} onClick={() => setNewCustomerMode(true)}>+ Yeni Müşteri Ekle</button>
                      </>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px', border: '1px solid var(--border, #e2e8f0)', borderRadius: '8px' }}>
                        <input className="input" placeholder="Ad" value={newCustomer.first_name} onChange={e => setNewCustomer({ ...newCustomer, first_name: e.target.value })} />
                        <input className="input" placeholder="Soyad" value={newCustomer.last_name} onChange={e => setNewCustomer({ ...newCustomer, last_name: e.target.value })} />
                        <input className="input" placeholder="Telefon" value={newCustomer.phone} onChange={e => setNewCustomer({ ...newCustomer, phone: e.target.value })} />
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button type="button" className="btn btn-secondary btn-sm" onClick={() => setNewCustomerMode(false)}>Vazgeç</button>
                          <button type="button" className="btn btn-primary btn-sm" onClick={createCustomerForReservation}>Müşteriyi Oluştur</button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="form-group"><label className="form-label">Oda</label>
                    <select className="select" value={form.room_id || ''} onChange={e => setForm({ ...form, room_id: e.target.value })}>
                      <option value="">Seçin</option>
                      {rooms.filter(r => r.status === 'available').map(r => <option key={r.id} value={r.id}>#{r.room_number} - {roomTypeLabels[r.room_type]}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Giriş</label>
                    <input type="date" className="input" value={form.check_in || ''} onChange={e => setForm({ ...form, check_in: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Çıkış</label>
                    <input type="date" className="input" value={form.check_out || ''} onChange={e => setForm({ ...form, check_out: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Misafir Sayısı</label>
                    <input type="number" className="input" value={form.guests_count || 1} onChange={e => setForm({ ...form, guests_count: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Toplam Fiyat (₺)</label>
                    <input type="number" className="input" value={form.total_price || ''} onChange={e => setForm({ ...form, total_price: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Özel İstekler</label>
                    <textarea className="textarea" value={form.special_requests || ''} onChange={e => setForm({ ...form, special_requests: e.target.value })} />
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModal({ open: false })}>İptal</button>
              <button className="btn btn-primary" onClick={modal.type === 'room' ? saveRoom : saveReservation}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .tabs-bar { display: flex; gap: 4px; background: var(--gray-100, #f1f5f9); padding: 4px; border-radius: 12px; margin-top: 16px; }
        .tab-btn { padding: 10px 20px; border: none; background: transparent; color: var(--gray-600, #475569); font-weight: 500; cursor: pointer; border-radius: 8px; transition: all 0.2s; }
        .tab-btn.active { background: white; color: var(--gray-900, #0f172a); box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
        .mt-4 { margin-top: 16px; }
      `}</style>
    </div>
  );
}

export default HotelReservations;
